
import {
  createApp,
  defineComponent,
  ref,
  reactive,
  onBeforeMount,
  onMounted,
  nextTick,
} from "vue";
import CustomAudio from "@/components/CustomAudio.vue";
import { unLock } from "@/utils/liner-lock";

export default defineComponent({
  name: "MultipleQuestion",
  props: {
    question: {
      type: Object,
    },
    disabled: {
      type: Boolean,
    },
    showQuestionNum: {
      type: Boolean,
      default: true,
    },
    showQuestionScore: {
      type: Boolean,
      default: true,
    },
  },
  setup(props, ctx) {
    const win: any = window;
    console.log("传入的题目", props.question);
    // 是否展示题号
    // 题目标准答案
    let correctOption: any = ref(props.question?.correct_option?.option_ids);
    // 转换成字母的标准答案
    let correctOptionLetter: any = ref([]);
    const disabledAnswer = ref(props.disabled);
    console.log("标准答案", correctOption);
    let answerResults = ref("错误");
    // 传进来的题目
    let questionData: any = ref(props.question);
    // 题目的选项
    let options = ref(props.question?.question_params.options);
    // 选中的答案
    let currentAnswer: any = ref([]);
    // 选项图片状态
    let clickImgState: any = ref(false);
    // 选项图片url
    let clickImgUrl: any = ref("");
    let updateImgH5List: any = ref([]);
    const testOptions: any = ref([
      {
        content: `<div>2<img src="https://devppublic.jilingshu.com.cn/exam_center/official/20220224/-rc-upload-1645665110516-53.jpg">
          <img src="https://devppublic.jilingshu.com.cn/exam_center/official/20220224/-rc-upload-1645665110516-57.jpg">
          <img src="https://devppublic.jilingshu.com.cn/exam_center/official/20220224/-rc-upload-1645665110516-54.jpg">
          <img src="https://devppublic.jilingshu.com.cn/exam_center/official/20220224/-rc-upload-1645665110516-55.jpg">
          </div>`,
        is_correct: 1,
        option_id: -2,
      },
      {
        content: `<div>1<img src="https://devppublic.jilingshu.com.cn/exam_center/institution/192/20221011/-rc-upload-1665467697221-15.jpg"></div>`,
        is_correct: 1,
        option_id: -1,
      },
      {
        content: `<div>3<img src="https://devppublic.jilingshu.com.cn/exam_center/institution/192/20221011/-rc-upload-1665467697221-15.jpg"></div>`,
        is_correct: 1,
        option_id: -3,
      },
      {
        content: `<div>4<img src="https://devppublic.jilingshu.com.cn/exam_center/institution/192/20221011/-rc-upload-1665467697221-15.jpg"></div>`,
        is_correct: 1,
        option_id: -4,
      },
    ]);
    // 转换数据
    const handleTitleHtml = () => {
      if (questionData.value.answer_params !== undefined) {
        currentAnswer.value = [...questionData.value.answer_params.option_ids];
      } else {
        currentAnswer.value = [];
      }

      let html = questionData.value.title;
      const audioExp = new RegExp("<kbd>.*?</kbd>", "g");
      const srcExp = new RegExp('src="([^"]+)');
      let match;
      let contentHtml = html;

      while ((match = audioExp.exec(html)) !== null) {
        contentHtml = contentHtml.replace(
          '<span style="color: rgb(159, 171, 183);">请点击按钮播放</span><span style="color: black;"> </span>',
          ""
        );
        const audioStr = match[0];
        const srcList: any = srcExp.exec(audioStr);
        const src = srcList?.length > 0 ? srcList[0] : "";
        const srcNum = src.replace(`src="`, "");
        const newStr = `<div class="dv-audio"><custom-audio musicUrl="${srcNum}" /></div>`;
        contentHtml = contentHtml.replace(audioStr, newStr);
      }

      const suffixTitle = `<img class="img-size" style="vertical-align: middle;" src="${require("@/assets/paper/tag-multi-choice.png")}" />`;
      contentHtml = `${contentHtml.slice(0, -6)}${suffixTitle}</div>`;

      const comp = defineComponent({
        template: `${contentHtml}`,
      });
      const app = createApp(comp);
      app.component("custom-audio", CustomAudio);
      nextTick(() => {
        app.mount("#dvCompile");
      });
    };
    // 修改选中选项
    const handleAnswer = (optionId: number) => {
      if (!props.disabled) {
        if (currentAnswer.value.includes(optionId)) {
          const restIds = currentAnswer.value.filter(
            (id: number) => id !== optionId
          );
          currentAnswer.value = restIds;
          // const answer_params =
          //   restIds.length === 0 ? undefined : { option_ids: [...restIds] };
          // ctx.emit("changePartsAnswer", {
          //   answer_params,
          // });
        } else {
          currentAnswer.value.push(optionId);
          // ctx.emit("changePartsAnswer", {
          //   answer_params: { option_ids: [...currentAnswer.value] },
          // });
        }
      }
    };
    // 选项数据转换
    const handleOptionHtml = () => {
      let match: any = [];
      let imgH5: any = [];
      const srcExp = new RegExp('src="([^"]+)');
      const imgExp = new RegExp("<img src", "g");
      const imgH5Exp = new RegExp("<img.*?>", "g");
      let updateImgH5: any;
      // 遍历出第一个选项
      options.value.forEach((data: any) => {
        // 处理选项里每个<img>标签
        let content: any = data.content;
        while ((imgH5 = imgH5Exp.exec(data.content)) !== null) {
          const srcList: any = srcExp.exec(imgH5);
          const src = srcList?.length > 0 ? srcList[0] : "";
          const srcTxt = src.replace(`src="`, "");
          const srcImg = `<img onClick="clickImg('${srcTxt}')" src`;
          updateImgH5 = imgH5[0].replace(imgExp, srcImg);
          content = content.replace(imgH5[0], updateImgH5);
        }
        data.content = content;
        match.push(data);
      });
      updateImgH5List.value = match;
    };
    // 父组件获取答案等参数
    const getAnswer = () => {
      // console.log("我是子组件11111", questionData.value);
      // console.log("currentAnswer.value", currentAnswer.value);
      // type:0|不保存答案 1｜保存答案
      if (questionData.value.correct_option) {
        const isCorrect =
          currentAnswer.value.sort().toString() ===
          questionData.value.correct_option.option_ids.sort().toString();
        if (isCorrect) {
          answerResults.value = "正确";
        } else {
          answerResults.value = "错误";
        }
      }
      if (currentAnswer.value.length === 0) {
        if (questionData.value.answer_params === undefined) {
          return { type: 0 };
        } else {
          return {
            answer_params: undefined,
            type: 1,
          };
        }
      } else {
        if (questionData.value.answer_params === undefined) {
          return {
            answer_params: { option_ids: currentAnswer.value },
            type: 1,
          };
        } else {
          if (
            questionData.value.answer_params.option_ids === currentAnswer.value
          ) {
            return { type: 0 };
          } else {
            return {
              answer_params: { option_ids: currentAnswer.value },
              type: 1,
            };
          }
        }
      }
    };
    const checkIsCorrect = () => {
      let isCorrect = false;
      if (questionData.value.answer_params) {
        isCorrect =
          questionData.value.answer_params.option_ids.sort().toString() ===
          questionData.value.correct_option.option_ids.sort().toString();
      }

      return isCorrect;
    };
    // 选项图片放大
    const clickImg = (url: any) => {
      console.log("图片放大", url);
      clickImgUrl.value = url;
      clickImgState.value = !clickImgState.value;
      event?.stopPropagation();
    };
    onBeforeMount(() => {
      handleTitleHtml();
      handleOptionHtml();
    });
    onMounted(() => {
      win.clickImg = clickImg;
      if (props.disabled) {
        const isCorrect = checkIsCorrect();
        if (isCorrect) {
          answerResults.value = "正确";
        } else {
          answerResults.value = "错误";
        }
      }

      handleTitleHtml;

      // 当标准答案不为空的时候处理标准答案选项
      if (correctOption.value) {
        let optionId = 0;
        options.value.forEach((option: any) => {
          if (correctOption.value.includes(option.option_id)) {
            const answerLetter = String.fromCharCode(65 + optionId);

            correctOptionLetter.value.push(answerLetter);
          }
          optionId++;
        });
        correctOptionLetter.value = JSON.stringify(correctOptionLetter.value);
        correctOptionLetter.value = correctOptionLetter.value.replace(/"/g, "");
        correctOptionLetter.value = correctOptionLetter.value.replace(
          /\[|]/g,
          ""
        );
      }
      // }
      unLock();
    });
    return {
      answerResults,
      questionData,
      options,
      currentAnswer,
      disabledAnswer,
      correctOption,
      correctOptionLetter,
      props,
      handleAnswer,
      getAnswer,
      checkIsCorrect,
      clickImg,
      clickImgState,
      clickImgUrl,
      updateImgH5List,
    };
  },
});
